import styled from 'styled-components'
import PersonIcon from '@material-ui/icons/Person'
import { colors, StyledLink } from '../../../theme/Global/index'

export const CompanyLogoContainer = styled.div`
  position: relative;
  float: right;
  top: ${(props) => (props.hasLogo ? '17px' : '10px')};
}
`

export const ToolbarLogoContainer = styled.div`
  margin-left: 16px;
  float: left;
  padding: 6px 0;
`

export const DashboardAppBar = {
  backgroundImage: `linear-gradient(${colors.govDocsBlue}, ${colors.mediumBlue}`,
  flex: 'auto',
  flexGrow: '0',
  height: '104px',
  justifyContent: 'center',
  padding: 0
}

export const StyledMenuContainer = styled.div`
  height: 38px;
`

export const StyledName = styled.div`
  display: inline-block;
`

export const StyledPersonIcon = styled(PersonIcon)`
  display: inline-block;
  position: relative;
  top: 7px;
  width: 24px;
`
export const CustomSeparator = styled.div`
  border-left: thin solid ${colors.white};
  display: inline-block;
  height: 38px;
  margin-left: 24px;
  margin-right: 20px;
  position: relative;
  top: 12px;
`

export const NavBar = styled.ul`
  overflow: hidden;
`

export const CustomLink = styled(StyledLink)`
  background-color: ${(props) => (props.active === 'true' ? colors.govDocsBlue : 'transparent')};
  color: ${colors.white};
  display: inline-block;
  margin-top: 12px;
  padding: 8px 16px;

  :hover {
    background-color: ${colors.govDocsBlue}
  }
`

export const StyledStageBanner = styled.div`
  background-color: ${colors.yellow};
  text-align: center;
  letter-spacing: .1em;
`
